export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6157.2bbe356f.jpg";